import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin, Modal, Form, Input, Row, Col } from 'antd';
import { BasicFormWrapper, SpinerCustomStyle } from '../container/styled';
import propTypes from 'prop-types';
import { Button } from '../components/buttons/buttons';
import formHelper from '../utility/formHelper';
import NotificationHelper from '../utility/notificationHelper';
import InputPhoneNumber from '../components/input/inputPhoneNumber';
import InputMail from '../components/input/inputMail';
import serviceHelper from '../utility/serviceHelper';
import { validatorEmail, validatorPhone, validatorTextRequired } from '../utility/andtCustomValidator';
import InputNumber from '../components/input/inputNumber';

function ReferansNoOlustur({ isModalVisible, handleCancel }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const initialState = {
    userDetail: {},
    currentStep: 0,
    visibleStatus: false,
    loading: false,
    kurumNodeList: [],
    userNode: {
      value: null,
      name: null,
    },
  };

  const [state, setState] = useState(initialState);

  const getKurumNodeList = async () => {
    const response = await serviceHelper.KurumNodeList();
    setState({
      ...state,
      kurumNodeList: response,
    });
  };

  useEffect(() => {
    getKurumNodeList();
  }, []);

  const SubmitForm = async () => {
    try {
      const formValue = formHelper.getFormValues(form);

      setState((prev) => ({ ...prev, loading: true }));

      if (!formHelper.isEmptyFieldVal(formValue)) {
        const res = await formHelper.formSubmit(
          `${process.env.REACT_APP_PROJE_REFERANS_NO_ODEME_KAYDI_OLUSTUR_ENDPOINT}`,
          {
            ...formValue,
          },
          'post',
          true,
        );

        if (res.responseStatus || res.responseData.isSuccess) {
          setState((prev) => ({ ...prev, userDetail: res.responseData.model, visibleStatus: true, loading: false }));
        }
      }
      setState((prev) => ({ ...prev, loading: false }));

      form.resetFields();
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      NotificationHelper.setErrorNotification(t('processUnexpectedError'));
    }
  };

  return (
    <div>
      <Modal title={t('referansNo')} visible={isModalVisible} onCancel={handleCancel} footer={null}>
        {state.loading && (
          <SpinerCustomStyle>
            <Spin />
          </SpinerCustomStyle>
        )}

        <div className="wizard-side-border">
          <div className="steps-content">
            <BasicFormWrapper className="basic-form-inner">
              <Row justify="center">
                <Col xs={24}>
                  <Form form={form} name="adres">
                    <Form.Item
                      name="barkodNo"
                      label={t('barkodNo')}
                      required
                      rules={[{ validator: validatorTextRequired }]}
                    >
                      <InputNumber integerOnly />
                    </Form.Item>

                    <Form.Item name="email" label={t('email')} required rules={[{ validator: validatorEmail }]}>
                      <InputMail />
                    </Form.Item>
                    <Form.Item name="ceptel" label={t('telefon')} required rules={[{ validator: validatorPhone }]}>
                      <InputPhoneNumber />
                    </Form.Item>

                    <Button type="success" size="large" onClick={SubmitForm}>
                      {t('olusturuldu')}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </BasicFormWrapper>
          </div>
        </div>
      </Modal>
    </div>
  );
}

ReferansNoOlustur.propTypes = {
  isModalVisible: propTypes.bool.isRequired,
  handleCancel: propTypes.func.isRequired,
};

export default ReferansNoOlustur;
